export default {
      id: "i-link-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/sprite.svg#i-link",
      toString: function () {
        return this.url;
      }
    }